import { P } from 'components'
import CustomButton from 'components/Buttons/CustomButton'
import usePartialUpload from 'hooks/usePartialUpload'
import { useSnackbar } from 'notistack'
import React, { useRef, useState, useEffect } from 'react'
import { X, Camera, Trash2 } from 'react-feather'
import Webcam from 'react-webcam'
import { Modal, ModalBody, Spinner } from 'reactstrap'

const ModalTakePhotoRelease = ({
  isOpen,
  toggle,
  callback,
  currentTotalFiles = 0,
  images,
  imageUrls,
  setImages,
  setImageUrls,
}) => {
  const webcamRef = useRef(null)
  const { uploadFile } = usePartialUpload()
  const { enqueueSnackbar } = useSnackbar()
  const [isUploading, setIsUploading] = useState(false)

  const handleCaptureAndUpload = async () => {
    if (currentTotalFiles + images.length >= 3) {
      enqueueSnackbar('Maksimal total 3 foto (upload + kamera)', {
        variant: 'error',
      })
      return
    }
    const imageSrc = webcamRef.current.getScreenshot()
    if (!imageSrc) return

    const blob = await fetch(imageSrc).then((res) => res.blob())
    const file = new File([blob], `confirmation-${images.length + 1}.jpg`, {
      type: 'image/jpeg',
    })

    try {
      setIsUploading(true)
      const result = await uploadFile(
        file,
        () => {},
        'USER_ID',
        'CONFIRMTRX',
        true,
      )
      if (result?.url) {
        setImages((prev) => [...prev, imageSrc])
        setImageUrls((prev) => [...prev, result.url])
      } else {
        enqueueSnackbar('Upload gagal. Coba lagi.', { variant: 'error' })
      }
    } catch (error) {
      enqueueSnackbar('Upload error. Coba lagi.', { variant: 'error' })
    } finally {
      setIsUploading(false)
    }
  }

  return (
    <Modal
      className="p-2"
      centered
      isOpen={isOpen}
      toggle={toggle}
      autoFocus={false}
      size="md"
      data-testid="detail-transaction-modal-take-photo"
    >
      <ModalBody className="p-4">
        <div className="text-center mb-4">
          <P size="large" className="fw-bold mb-2" color="#101828">
            Ambil Foto Konfirmasi
          </P>
          <P size="regular" className="text-muted">
            Silakan ambil foto sebagai bukti sebelum Anda mengonfirmasi transaksi. (Maksimal 3 foto)
          </P>
        </div>

        <div className="position-relative mb-4 overflow-hidden rounded-lg shadow-sm border" style={{ aspectRatio: '4/3', backgroundColor: '#f9fafb' }}>
          {images.length < 3 ? (
            <Webcam
              ref={webcamRef}
              audio={false}
              screenshotFormat="image/jpeg"
              className="w-100 h-100"
              style={{ objectFit: 'cover' }}
            />
          ) : (
            <div className="w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-light">
              <Camera size={48} className="text-muted mb-2" />
              <P size="regular" className="text-muted fw-medium">Batas foto tercapai</P>
            </div>
          )}
          
          {isUploading && (
            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center" style={{ backgroundColor: 'rgba(255, 255, 255, 0.7)', zIndex: 10 }}>
              <Spinner color="primary" className="mb-2" />
              <P size="small" className="fw-medium text-primary">Mengunggah...</P>
            </div>
          )}
        </div>

        {images.length > 0 && (
          <div className="d-flex flex-wrap gap-2 mb-4">
            {images.map((img, idx) => (
              <div
                key={idx}
                className="position-relative rounded overflow-hidden border shadow-sm"
                style={{ width: '80px', height: '80px' }}
              >
                <img
                  src={img}
                  alt={`Captured-${idx}`}
                  className="w-100 h-100"
                  style={{ objectFit: 'cover' }}
                />
                <div 
                  className="position-absolute top-0 end-0 p-1"
                  style={{ cursor: 'pointer', backgroundColor: 'rgba(255, 255, 255, 0.8)' }}
                  onClick={() => {
                    setImages((prev) => prev.filter((_, i) => i !== idx))
                    setImageUrls((prev) => prev.filter((_, i) => i !== idx))
                  }}
                >
                  <Trash2 size={14} className="text-danger" />
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="mb-4">
          <CustomButton
            onClick={handleCaptureAndUpload}
            color="primary"
            block
            disabled={images.length >= 3 || isUploading}
            className="py-2 fw-semibold d-flex align-items-center justify-content-center gap-2"
          >
            <Camera size={18} />
            {images.length >= 3 ? 'Batas Foto Tercapai' : 'Ambil Foto'}
          </CustomButton>
        </div>

        <div className="d-flex gap-3">
          <CustomButton 
            onClick={toggle} 
            className="btn-cancel py-2 fw-semibold border-0" 
            style={{ backgroundColor: '#F2F4F7', color: '#344054' }}
            block
            testId="detail-transaction-modal-take-photo-cancel"
          >
            Batal
          </CustomButton>
          <CustomButton
            color="primary"
            disabled={imageUrls.length === 0 || isUploading}
            block
            onClick={() => {
              callback({ images: imageUrls, imageUrls: imageUrls })
              toggle()
            }}
            className="py-2 fw-semibold"
            testId="detail-transaction-modal-take-photo-submit"
          >
            Lanjut
          </CustomButton>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ModalTakePhotoRelease

